module.exports = "<div id=\"data-zoom-layer\">\r\n    <button class=\"unstyled close\">\r\n        <svg><use xlink:href=\"#startup-close\"></use></svg>\r\n    </button>\r\n    <button class=\"unstyled next\">\r\n        <svg><use xlink:href=\"#startup-right\"></use></svg>\r\n    </button>\r\n    <button class=\"unstyled prev\">\r\n        <svg><use xlink:href=\"#startup-left\"></use></svg>\r\n    </button>\r\n    <div class=\"img-container\">\r\n\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./project/_src/components/data-zoom-layer.html
// module id = 7
// module chunks = 0